import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { ShowhistoryPage } from '../routing/routeindoor/reportorderindoor/showhistory/showhistory';
import { ClinicopenroomPage } from '../clinicopenroom/clinicopenroom';

/**
 * Generated class for the IndoorassetPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-indoorasset',
  templateUrl: 'indoorasset.html',
})
export class IndoorassetPage {
  counter = Array;
  loading = false;
  dataLegend = []
  rows = []
  cols = []
  _roomsdb = []
  _cellsize: any
  cells = []
  _roomsEl = []
  _floors = []
  floorsTop;
  _idxFloor;

  durationInterval: any
  isInInterval: boolean = false
  liveOptionsRight = false;

  Roletna: boolean = false
  _empdashboard = []
  _empdashboardG = []
  _historyData = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public modalCtrl: ModalController) {

  }



  ionViewDidLoad() {
    this.rows = this.range(0, 25);
    this.cols = this.range(0, 37);
    this.cells = this.range(0, 987);
    for (var o = 0; o < this.gn.Organisations.length; o++) {
      this.gn.Organisations[o].expand = true;
    }
    this.loadData();
  }

  loadRoletna() {
    var _that = this
    this.gn._Post('/api/gn/getEmployeeDashboard', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that._empdashboard = _data

      var _temp = []
      for (var i = 0; i < _data.length; i++) {
        var _curr = _data[i].driverid
        if (_data[i].pinid != -1) _curr = _data[i].pinid

        var _next = -1
        if (_data[i + 1] != undefined) {
          _next = _data[i + 1].driverid
          if (_data[i + 1].pinid != -1) _next = _data[i + 1].pinid
        }

        var x = _data[i]
        x.Visible = true
        _temp.push(x)
        if (_next != _curr) {
          _that._empdashboardG.push({ Visible: true, title: _data[i].pinusername, process: _data[i].process, arr: _temp })
          _temp = []
        }

      }
      _that.Roletna = !_that.Roletna
      //debugger
    })
  }

  hideLiveOptionsRight() {
    this.liveOptionsRight = !this.liveOptionsRight;
  }

  selectFloor(_idxFloor) {
    this._idxFloor = _idxFloor;
    this._roomsEl = []
    this.setLayout();
  }

  setLayout() {
    var _that = this
    this.gn._Post('/api/gn/getRoomsLayout', { cid: this.gn.crypt(this.gn.user.ClientId), idxFloor: this.gn.crypt(this._idxFloor) }, function (_data) {
      _that._roomsdb = _data

      for (var room = 0; room < _that._roomsdb.length; room++) {
        var _width = ((_that._roomsdb[room].maxcol - _that._roomsdb[room].mincol + 1) * _that._cellsize) - 4 + 'px'
        var _roomnum = ((_that._roomsdb[room].maxcol - _that._roomsdb[room].mincol + 1) * _that._cellsize) - 21 + 'px'
        var _height = ((_that._roomsdb[room].maxrow - _that._roomsdb[room].minrow + 1) * _that._cellsize) - 4 + 'px'
        var _roomnumtop = '-10px';//((_that._roomsdb[room].maxrow - _that._roomsdb[room].minrow + 1) * _that._cellsize) - 32 + 'px'
        var _height1 = ((_that._roomsdb[room].maxrow - _that._roomsdb[room].minrow + 1) * _that._cellsize) - 27 + 'px'


        var _left = /*(document.getElementById('kikilist').offsetWidth) + */(_that._roomsdb[room].mincol * _that._cellsize)/*+15*/ + 'px'
        //var _left = (_that._roomsdb[room].mincol*_that._cellsize)+15+'px'
        //var _top = document.getElementById('divider').offsetTop+15+(_that._roomsdb[room].minrow*_that._cellsize)+'px'
        var _top = /*15+*/(_that._roomsdb[room].minrow * _that._cellsize) - 1 + 'px'
        //var _top = 15+(_that._roomsdb[room].minrow*_that._cellsize)+'px'

        var _notifleft = ((_that._roomsdb[room].maxcol - _that._roomsdb[room].mincol + 1) * _that._cellsize) / 2 - 12 + 'px'
        var _notiftop = ((_that._roomsdb[room].maxrow - _that._roomsdb[room].minrow + 1) * _that._cellsize) - 11 + 'px'


        var cntroom = _that.gn.allDevices.find(obj => {
          return obj != undefined && obj.roomid === _that._roomsdb[room].id
        })
        var isgps = _that.gn.Vehicles.find(obj => {
          return obj.roomid + '' === _that._roomsdb[room].id + ''
        })
        var cnt = 0
        if (cntroom != undefined) {
          cnt = cntroom.cnt
        }
        if (room == 0) {
          var _widthBase = (38 * _that._cellsize) - 4 + 'px'
          var _roomnumBase = undefined
          var _heightBase = (26 * _that._cellsize) - 4 + 'px'
          var _roomnumtopBase = '-14px';//((_that._roomsdb[room].maxrow - _that._roomsdb[room].minrow + 1) * _that._cellsize) - 32 + 'px'
          var _height1Base = (26 * _that._cellsize) - 30 + 'px'
          var _leftBase = '0px'
          var _topBase = '-1px'

          _that._roomsEl.push({ notiftop: 0, notifleft: 0, notif: '', isgps: undefined, roomnumtop: _roomnumtopBase, roomnum: _roomnumBase, cnt: 0, roomid: -1, text: '', top: _topBase, left: _leftBase, color: '#c4c4c4', colorpulse: '#c4c4c4', colorpulse1: '#c4c4c4', colorpulse2: '#c4c4c4', height: _heightBase, height1: _height1Base, width: _widthBase })
        }

        _that._roomsEl.push({ notiftop: _notiftop, notifleft: _notifleft, notif: _that._roomsdb[room].notifcolor, isgps: isgps, roomnumtop: _roomnumtop, roomnum: _roomnum, cnt: cnt, roomid: _that._roomsdb[room].id, text: _that._roomsdb[room].room, top: _top, left: _left, color: _that._roomsdb[room].color, colorpulse: _that.hex2rgb(_that._roomsdb[room].color, 0.5), colorpulse1: _that.hex2rgb(_that._roomsdb[room].color, 0.6), colorpulse2: _that.hex2rgb(_that._roomsdb[room].color, 0.1), height: _height, height1: _height1, width: _width })
        //_that._roomsEl.push({text: _that._roomsdb[room].room, top: _top, color: _that._roomsdb[room].color, height: _height, width: _width})
      }
    });
  }

  hex2rgb(hex, opacity) {
    var h = hex.replace('#', '');
    h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));

    for (var i = 0; i < h.length; i++)
      h[i] = parseInt(h[i].length == 1 ? h[i] + h[i] : h[i], 16);

    if (typeof opacity != 'undefined') h.push(opacity);

    return 'rgba(' + h.join(',') + ')';
  }

  ionViewWillLeave() {
    this.isInInterval = false
    if (this.durationInterval != null) {
      clearInterval(this.durationInterval)
      this.durationInterval = null
    }
  }

  loadData() {
    this.gn._Post('/api/gn/getFloors', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that._floors = _data
      _that.floorsTop = "calc(50% - " + (_that._floors.length / 2) * 50 + "px)"
      _that._idxFloor = _data[0].floor
      //alert(_that.floorsTop)
    })

    var _that = this
    if (this.durationInterval == null) {
      this.isInInterval = false
      _that.durationInterval = setInterval(function () {
        if (_that.isInInterval == false) {
          _that.isInInterval = true

          ///
          for (var i = 0; i < _that.gn.allDevices.length; i++) {
            if (_that.gn.allDevices[i] != undefined) {
              for (var j = 0; j < _that.gn.allDevices[i].length; j++) {
                if (_that.gn.allDevices[i] != undefined) {
                  if (_that.gn.allDevices[i][j] != undefined) {
                    if (_that.gn.allDevices[i][j].enddt == '/') {
                      _that.gn.allDevices[i][j].duration = parseInt(_that.gn.allDevices[i][j].duration) + 1
                    }
                  }
                }

              }
            }
          }
          _that.isInInterval = false
        }
      }, 1000)
    }

    this.loading = false;
    this.gn.allDevices = []
    this.gn.allDevicesIds = []
    this.dataLegend = []

    this.gn._Post('/api/gn/getcurrentbeacons', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_dataCurrent) {
      _that.gn._Post('/api/gn/getclinicrooms', { cid: _that.gn.crypt(_that.gn.user.ClientId) }, function (_data) {
        _that.dataLegend = _data.datalegend
        _data = _data.data
        for (var i = 0; i < _data.length; i++) {
          var cnt = 0;
          _that.gn.allDevicesIds.push(_data[i].id)

          _that.gn.allDevices[_data[i].id] = []
          _that.gn.allDevices[_data[i].id].roomid = _data[i].id
          _that.gn.allDevices[_data[i].id].room = _data[i].room
          _that.gn.allDevices[_data[i].id].color = _data[i].color
          _that.gn.allDevices[_data[i].id].colorpulse = _that.hex2rgb(_data[i].color, 0.1);//_data[i].colorpulse
          _that.gn.allDevices[_data[i].id].notifcolor = _data[i].notifcolor
          _that.gn.allDevices[_data[i].id].expand = true


          for (var c = 0; c < _dataCurrent.length; c++) {
            if (_dataCurrent[c].fulldata != null) {
              var arrdata = _dataCurrent[c].fulldata.split('~')
              var roomname = arrdata[6];//.toLowerCase()//replace(" ", "")
              //if (_data[i].room.toLowerCase() == roomname.toLowerCase() || _data[i].room.toLowerCase() == roomname.replace(" ", "").toLowerCase()) {
              if (_data[i].id == _that.gn.Vehicles[_that.gn.VehiclesDic[arrdata[1]]].roomid) {
                var _enddate = '/'
                if (arrdata[3] != '/') {
                  _enddate = moment(arrdata[3]).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
                } else {
                  cnt++;
                }
                var org = _that.gn.Organisations.find(obj => {
                  return obj.id + '' === arrdata[7] + ''
                })
                var _orgcolor;
                if (org == undefined) _orgcolor = '#0537f9';
                else _orgcolor = org.color;

                _that.gn.allDevices[_data[i].id].push({ beaconid: arrdata[0], vehid: arrdata[1], orgcolor: _orgcolor, fullname: arrdata[5], code: _dataCurrent[c].code, dt: moment(arrdata[2]).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), enddt: _enddate, duration: arrdata[8] /*_that.sec2str3(arrdata[8])*/, visible: true, orgid: arrdata[7] })
              }
            }
          }

          _that.gn.allDevices[_data[i].id].cnt = cnt;

          if (i == _data.length - 1) {
            // document.getElementById('kikiimg').style.maxHeight = (document.getElementById('kiki').offsetHeight - 40) + 'px'

            // setTimeout(() => {
            _that.setLayout();
            // document.getElementById('kikilist').style.width = (document.getElementById('kiki').offsetWidth - document.getElementById('kikiimg').offsetWidth) + 'px'
            //layout
            //_that._cellsize = (document.getElementById('layout').offsetWidth-34)/38
            _that._cellsize = (document.getElementById('layout').offsetWidth) / 38
            document.getElementById('layout').style.height = _that._cellsize * 26 + 'px'
            _that.loading = true;
            // }, 100);

          }
        }
      })
    })
  }

  openRoom(_did) {
    if (this.gn.allDevices[_did] != undefined) {
      var _that = this
      let modal = this.modalCtrl.create(ClinicopenroomPage, {
        d: _that.gn.allDevices[_did], did: _did, cb: function () {
          // _that.loadData()
        }
      },
        { cssClass: "modal-fullscreen-clinic" }
      );
      modal.present();
    }
  }

  searchItems(_ev) {
    // var txt = _ev.target.value
    // console.log(txt)
    this.getItems(_ev)
  }

  getItems(ev: any) {
    let val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()

    this.searchInRooms(val)
  }

  sec2str3(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  searchInRooms(val) {
    var val1 = this.gn._cyrlat(val)
    var val2 = this.gn._latcyr(val)

    if (val && val.trim() != '') {
      for (var i = 0; i < this.gn.allDevicesIds.length; i++) {
        for (var j = 0; j < this.gn.allDevices[this.gn.allDevicesIds[i]].length; j++) {
          if (this.gn.allDevices[this.gn.allDevicesIds[i]][j].fullname.toLowerCase().indexOf(val1) > -1 || this.gn.allDevices[this.gn.allDevicesIds[i]][j].fullname.toLowerCase().indexOf(val2) > -1) {
            this.gn.allDevices[this.gn.allDevicesIds[i]][j].visible = true;
          } else {
            if (this.gn.allDevices[this.gn.allDevicesIds[i]][j].code.toLowerCase().indexOf(val1) > -1 || this.gn.allDevices[this.gn.allDevicesIds[i]][j].code.toLowerCase().indexOf(val2) > -1) {
              this.gn.allDevices[this.gn.allDevicesIds[i]][j].visible = true;
            } else {
              this.gn.allDevices[this.gn.allDevicesIds[i]][j].visible = false;
            }
          }
        }
      }
      // for (var i = 0; i < this.gn.Vehicles.length; i++) {
      //   if (this.gn.Vehicles[i].registration.toLowerCase().indexOf(val1) > -1 || this.gn.Vehicles[i].registration.toLowerCase().indexOf(val2) > -1) {
      //     this.gn.Vehicles[i].searchVisible = true
      //   } else {
      //  this.gn.Vehicles[i].searchVisible = false
      //}
      // }
    } else {
      this.resetSearch()
    }
  }

  resetSearch() {
    for (var i = 0; i < this.gn.allDevicesIds.length; i++) {
      for (var j = 0; j < this.gn.allDevices[this.gn.allDevicesIds[i]].length; j++) {
        this.gn.allDevices[this.gn.allDevicesIds[i]][j].visible = true;
      }
    }
  }

  range(start, end) {
    var ans = [];
    for (let i = start; i <= end; i++) {
      ans.push(i);
    }
    return ans;
  }

  resetSearch1() {
    for (var i = 0; i < this._empdashboardG.length; i++) {
      this._empdashboardG[i].Visible = true
      for (var j = 0; j < this._empdashboardG[i].arr.length; j++) {
        this._empdashboardG[i].arr[j].Visible = true
      }
    }
  }
  getItems1(ev: any) {
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchEmpDashboard(val);

  }

  searchEmpDashboard(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this._empdashboardG.length; i++) {
        var hasData = 0;
        for (var j = 0; j < this._empdashboardG[i].arr.length; j++) {
          //debugger
          if (this.gn._latcyr(this._empdashboardG[i].arr[j].routetitle.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this._empdashboardG[i].arr[j].routetitle.toLowerCase()).indexOf(val) > -1) {
            this._empdashboardG[i].arr[j].Visible = true
            hasData++;
          } else {
            if (this.gn._latcyr(this._empdashboardG[i].arr[j].process.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this._empdashboardG[i].arr[j].process.toLowerCase()).indexOf(val) > -1) {
              this._empdashboardG[i].arr[j].Visible = true
              hasData++
            }
            else {
              if (this.gn._latcyr(this._empdashboardG[i].arr[j].pinusername.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this._empdashboardG[i].arr[j].pinusername.toLowerCase()).indexOf(val) > -1) {
                this._empdashboardG[i].arr[j].Visible = true
                hasData++
              } else {
                if (this.gn._latcyr(this._empdashboardG[i].arr[j].article.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this._empdashboardG[i].arr[j].article.toLowerCase()).indexOf(val) > -1) {
                  this._empdashboardG[i].arr[j].Visible = true
                  hasData++
                } else {
                  this._empdashboardG[i].arr[j].Visible = false
                }
              }
            }
          }
        }
        if (hasData > 0) this._empdashboardG[i].Visible = true
        else this._empdashboardG[i].Visible = false
      }
    }
    else {
      this.resetSearch1()
    }
  }

  historyNalog(_routeid) {
    var _dat = {
      routeid: this.gn.crypt(_routeid)
    }
    var _that = this
    this.gn._Post('/api/gn/getrouteindoorbyid', _dat, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        _data[i].datumcreate = moment(_data[i].dt_create).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _data[i].orgdt = _data[i].dt
        _data[i].dt = moment(_data[i].dt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _data[i].crimp = _data[i].byapi + '' == '1' ? _that.dic.l["importedPantheon"] : _that.dic.l["createdPanorama"]
        _data[i].cartnames = (_data[i].cartnames + '' == '' || _data[i].cartnames == null) ? '/' : _data[i].cartnames
        _data[i].komentar = (_data[i].komentar + '' == '' || _data[i].komentar == null) ? '' : _data[i].komentar
        _data[i].visible = true;
        _data[i].dt_done = moment(_data[i].dt_done).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _data[i].dt_create = moment(_data[i].dt_create).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
      }
      _that._historyData = _data[0]

      let modal = _that.modalCtrl.create(ShowhistoryPage, {
        drn: _that._historyData,
        cb: function (_id) {
          //debugger
          //_that.doLoadImported(_id)
        }
      }, { cssClass: "modal-fullscreen3" });
      modal.present();
    })
  }


}



// WEBPACK FOOTER //
// ./src/pages/indoorasset/indoorasset.ts